import $ from 'jquery';

$('[data-organization-create-edit-form]')
    .each(function () {
        const container = $(this);

        const organizationIsDisabled = container.attr('data-organization-is-disabled');
        if (organizationIsDisabled === 'True') {
            disableElements();
        }

        const brregUrl = container.attr('data-brreg-api-url');

        const organizationNumber = $('#RegistrationNumber');
        if (organizationNumber) {
            const mode = organizationNumber.attr('data-mode');
            if (mode === 'create') {
                organizationNumber.on('blur', function (evt) {
                    const current = $(evt.currentTarget);
                    if (current.attr('aria-invalid') === 'false') {
                        SyncAddressFromBrreg(current.val());
                    }
                });
            }

            $('#BrregSyncAddress').on('click', function () {
                SyncAddressFromBrreg(organizationNumber.val());
            });
        }

        function SyncAddressFromBrreg(organizationNumber) {
            $.ajax({
                url: brregUrl + `?organizationNumber=${organizationNumber.replace(/\s+/g, '')}`,
                async: false,
                dataType: 'json',
                success: function (data) {
                    if (data) {
                        $('#BillingAddress_AddressLine').val(data.AddressLine);
                        $('#BillingAddress_PostNumber').val(data.PostNumber);
                        $('#BillingAddress_City').val(data.City);

                        const name = $('#Name');
                        if (!name.val()) {
                            name.val(data.CompanyName);
                        }
                    }
                }
            });
        }

        function disableElements() {
            const toDisable = [
                'input[type=radio]', 'input[type=checkbox]', 'input[type=file]', 'textarea', 'button:not(#Reactivate)'
            ];

            $.each(toDisable,
                function (index, value) {
                    container.find('' + value + '').each(function () {
                        $(this).attr('disabled', 'disabled');
                    });
                });

            container.find('input[type=text]').each(function () {
                $(this).attr('readonly', 'readonly');
            });
        }

        const inheritSection = $('#invoiceInheritSection');
        const addressSection = $('#invoiceAddressSection');
        $('input[type=radio][name=InvoiceMethod]').change(function () {
            switch (this.value) {
            case 'Inherit':
                inheritSection.show();
                addressSection.hide();
                break;
            case 'InvoiceAddress':
                inheritSection.hide();
                addressSection.show();
                break;
            default:
                inheritSection.hide();
                addressSection.hide();
                break;
            }
        });
    });

$.validator.addMethod('brregorganizationvalidation',
    function (value) {
        value = value.replace(/\s/g, '');

        const apiURL = `organizationvalidation?orgNumber=${value}`;
        let isValid = false;
        const orgName = $('input.organization-name').val();

        $.ajax({
            url: apiURL,
            async: false,
            dataType: 'json',
            success: function (data) {
                isValid = data.CompanyNumber === value && data.CompanyName === orgName.toUpperCase();
            }
        });

        return isValid;
    }, function (params, element) {
        return $(element).attr('data-val-brregorganizationvalidation');
    });

$.validator.unobtrusive.adapters.addBool('brregorganizationvalidation', 'brregorganizationvalidation');

$('.selectpicker').selectpicker({
    size: 5
});

let waitTimer;
$('#ServiceFilter').on('change', function () {
    clearTimeout(waitTimer);
    const form = $(this).closest('form');
    waitTimer = setTimeout(function () {
        form.submit();
    }, 1000);
});

$('#AdvancedSettings').on('click', function () {
    const advancedSettingsPanel = $('#AdvancedSettingsPanel');
    advancedSettingsPanel.toggle();
});

$('.bicycle-check input').on('click', function (e) {
    const check = $(e.target);
    const checked = check.is(':checked');

    $('.bicycle-settings').toggleClass('show', check);
    if (!checked) {
        $('#BicycleCount').val('0');
        $('#ChargingStationCount').val('0');
    }
});

$('#AddNoteBtn').on('click', function (e) {
    e.preventDefault();
    const orgId = $('#OrgId').val();
    const currentUser = $('#CurrentUser').val();
    const note = $('#Note').val();
    const notes = $('.notes');
    const noteTemplate = $('.note-template').clone();
    const noteError = $('.note-error');

    $.ajax({
        url: `/OrganizationAdminPage/addnote?organizationId=${orgId}&note=${note}`,
        type: 'POST',
        async: false,
        success: function (data) {
            $(noteError).hide();
            $(noteTemplate).find('.note-text').html(note);
            $(noteTemplate).find('.username').html(currentUser);
            $(noteTemplate).find('.delete-note').attr('data-note-id', data.toString());
            $(noteTemplate).show();
            $(notes).prepend(noteTemplate);
            $('#Note').val('');
        },
        error: function () {
            $(noteError).show();
        }
    });
});

$('.notes').on('click', '.delete-note', function (e) {
    e.preventDefault();
    const confirmMessage = $('.notes').attr('data-delete-confirm-message');
    if (window.confirm(confirmMessage)) {
        const noteId = $(this).attr('data-note-id');
        const noteError = $('.note-error');
        const scope = $(this);

        $.ajax({
            url: `/OrganizationAdminPage/deletenote?noteid=${noteId}`,
            type: 'POST',
            async: false,
            success: function () {
                $(scope).closest('.note-item').remove();
            },
            error: function () {
                $(noteError).show();
            }
        });
    }
});

$('#DocumentData').hide();
$('#DocumentType').hide();

$('#DocumentButton').on('click', function (evt) {
    evt.preventDefault();
    const fileUploadArea = $('#DocumentData');
    fileUploadArea.click();
});

$('#DocumentData').on('change', function () {
    const fileUploadArea = $('#DocumentData');
    const allowedExtensions = ['pdf'];
    const uploadedFileNames = $('#UploadedFileName');
    const fileName = $('#DocumentData').val().match(/[^\\/]+$/)[0];
    let extension = fileName.replace(/^.*\./, '');

    if (extension === fileName) {
        extension = '';
    } else {
        extension = extension.toLowerCase();
    }

    if ($.inArray(extension, allowedExtensions) === -1) {
        window.alert('Only formats are allowed : ' + allowedExtensions.join(', '));
        fileUploadArea.val('');
    } else {
        uploadedFileNames.empty();
        const listItem = $('<li class="list-group-item"></li>').text(fileName);
        uploadedFileNames.append(listItem);
        $('#DocumentType').show();
    }
});
